import React, { useEffect, useState } from "react";
import { Loader2, Megaphone, Film, Image as ImageIcon } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { StatusShare } from "@/pages/admin/marketing/StatusShare";
import { mediaUrl } from "@/pages/admin/marketing/mkMedia";

const Card = ({ item, i }) => (
  <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm" data-testid={`teacher-mk-item-${i}`}>
    <div className="aspect-[9/16] max-h-[420px] w-full bg-slate-900 flex items-center justify-center">
      {item.kind === "video"
        ? <video src={mediaUrl(item.path)} poster={item.cover ? mediaUrl(item.cover) : undefined} controls playsInline preload="metadata" className="h-full w-full object-contain" data-testid={`teacher-mk-video-${i}`} />
        : <img src={mediaUrl(item.path)} alt={item.title} className="h-full w-full object-contain" data-testid={`teacher-mk-image-${i}`} />}
    </div>
    <div className="p-3 space-y-2">
      <div className="flex items-center gap-2 text-xs text-slate-500">
        {item.kind === "video" ? <Film className="h-3.5 w-3.5" /> : <ImageIcon className="h-3.5 w-3.5" />}
        {item.kind === "video" ? "Reel" : "Photo"} · {formatDate(item.approved_at)}
      </div>
      <p className="font-bold text-slate-900 text-sm">{item.title}</p>
      <p className="text-xs text-slate-600 whitespace-pre-wrap line-clamp-4" data-testid={`teacher-mk-caption-${i}`}>{item.caption}</p>
      <StatusShare item={item} testPrefix={`teacher-mk-${i}`} />
    </div>
  </div>
);

export default function TeacherMarketing() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/marketing/library").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div className="space-y-4" data-testid="teacher-marketing">
      <div>
        <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Megaphone className="h-5 w-5 text-blue-700" /> PTG Marketing</h2>
        <p className="text-sm text-slate-500">Approved PTG posts ready for your WhatsApp Status (9:16). Share as they are — please don't edit them.</p>
      </div>
      {items === null ? <Loader2 className="h-6 w-6 animate-spin text-blue-700" /> : items.length === 0 ? (
        <p className="text-sm text-slate-500 rounded-xl border border-dashed border-slate-300 p-6 text-center" data-testid="teacher-mk-empty">No approved marketing content yet.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">{items.map((x, i) => <Card key={x.id} item={x} i={i} />)}</div>
      )}
    </div>
  );
}
